import { type LucideIcon } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

export interface EntityEmptyStubProps {
  /** Lucide icon component, rendered centred above the title. */
  icon: LucideIcon;
  /** Headline copy — should read as a neutral "no data yet" state, not "coming soon". */
  title: string;
  /** Optional one-line subtitle explaining what would appear here. */
  helper?: string;
}

/**
 * Neutral empty-state card for detail-page tabs whose feature is built
 * but currently has no data. Distinct from {@link EntityComingSoonStub}
 * (which is reserved for unbuilt features).
 */
export function EntityEmptyStub({ icon: Icon, title, helper }: EntityEmptyStubProps) {
  return (
    <Card>
      <CardContent className="flex flex-col items-center justify-center py-12 text-center">
        <Icon className="mb-3 h-8 w-8 text-muted-foreground" aria-hidden="true" />
        <h3 className="mb-1 text-base font-medium text-foreground">{title}</h3>
        {helper ? (
          <p className="max-w-md text-sm text-muted-foreground">{helper}</p>
        ) : null}
      </CardContent>
    </Card>
  );
}
